module.exports = __webpack_public_path__ + "img/star_0_5.25e013fa.png";